import React from 'react'

const AboutNew = () => {
  return (
    <div>
      
  
  <div className="titles">
  Why Choose GKM Power Projects Pvt Ltd:
  </div>
  <div className="details">
  <ul>
  
    <li> <b> Proven Track Record : </b> Our track record speaks volumes about our dedication to excellence and customer satisfaction. <br></br>
</li>  <li>
<b> Expert Team : </b>Our team of experienced professionals is dedicated to understanding your unique requirements and offering tailored solutions. <br></br>
</li> <li>
<b> Sustainable Practices : </b> GKM Power Projects Pvt Ltd is committed to sustainable and environmentally conscious practices. Our equipment is designed with energy efficiency in mind, contributing to a greener future. </li>
Please feel free to contact us at : <b> +91 9811080335 </b>to schedule a meeting or request more information about our products and services. <br></br>
<b>
Thank you for considering GKM Power Projects Pvt Ltd as your power solutions partner. We look forward to the possibility of working together to power your success.</b>
</ul>
  </div>

    </div>
  )
}

export default AboutNew
